@if (quota(); as quota) {
  <div class="menu-bar-badge-container">
    @if (hasCount(quota.callsLeftForEmployee)) {
      <div class="menu-bar-badge">
        <span class="menu-bar-badge-text" i18n
          >{{ quota.callsLeftForEmployee }} Anrufe verfügbar</span
        >
      </div>
    } @else if (hasCount(quota.callsLeftForTenant)) {
      <div class="menu-bar-badge">
        <span class="menu-bar-badge-text" i18n
          >{{ quota.callsLeftForTenant }} Anrufe verfügbar</span
        >
      </div>
    }
  </div>
}
